import React from "react";
import { Box } from "@mui/material";
import EmailTemplatesPage from "../../components/EmailTemplates";

function EmailTemplatesRoute() {
  return (
    <Box height="100%" width="100%">
      <EmailTemplatesPage />
    </Box>
  );
}

export default EmailTemplatesRoute;
